export { default } from '@shikijs/langs/pascal'
